import { gql } from '@apollo/client'
import { useActionMutation } from '@ztechapps/common.hook'
import type { Chat, MarkChatReadArgs } from '@ztechapps/common.contract'

export const markChatReadQuery = gql`
  mutation markChatRead($input: MarkChatReadArgs!) {
    markChatRead(input: $input) {
      _id
      unreadForAgentCount
    }
  }
`

/**
 * Marks a conversation read via the markChatRead mutation — the surviving read path now
 * that the generic message update surface is gone. Returns the standard useActionMutation
 * tuple — call `markChatRead({ chatId })`.
 */
export const useMarkChatRead = () => useActionMutation<Chat, MarkChatReadArgs>({ query: markChatReadQuery })
